export class Pagination {
    limit = 1;
    offset = 0;

    constructor(limit: number, offset: number) {
        this.limit = limit;
        this.offset = offset;
    }
}



// WEBPACK FOOTER //
// /app/src/model/Helpers/Pagination.ts